import React, { useEffect, useState } from "react";
import { TOKEN_KEY } from "../lib/api";

/** <img> for files served from /api/files/{id} that require auth.
 *  Uses ?auth=<token> query param fallback supported by backend. */
export default function AuthImg({ fileId, alt = "", className = "", style, onClick }) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    if (!fileId) return;
    const token = localStorage.getItem(TOKEN_KEY);
    const base = process.env.REACT_APP_BACKEND_URL;
    setSrc(`${base}/api/files/${fileId}${token ? `?auth=${encodeURIComponent(token)}` : ""}`);
  }, [fileId]);
  if (!src) return null;
  return <img src={src} alt={alt} className={className} style={style} onClick={onClick} loading="lazy" />;
}
